import { useMemo } from 'react';

export const useSort = (
    items = [],
    sortField,
    sortDirection,
    sortAccessor = null
) => {
    return useMemo(() => {
        if (!sortField || items.length === 0) return items;

        return [...items].sort((a, b) => {
            const field = sortAccessor || sortField;
            const aVal = a[field];
            const bVal = b[field];

            // Handle null or undefined values
            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return -sortDirection;
            if (bVal == null) return sortDirection;

            // If both values are strings, perform case-insensitive comparison
            if (typeof aVal === 'string' && typeof bVal === 'string') {
                const aLower = aVal.toLowerCase();
                const bLower = bVal.toLowerCase();

                if (aLower > bLower) return sortDirection;
                if (aLower < bLower) return -sortDirection;
                return 0;
            }

            // For numbers or other types, perform standard comparison
            if (aVal > bVal) return sortDirection;
            if (aVal < bVal) return -sortDirection;
            return 0;
        });
    }, [items, sortField, sortDirection, sortAccessor]);
};
